angular.module('analytics', ['ng']).service('analytics', [
    '$rootScope', '$window', '$location', function($rootScope, $window, $location) {
        var track = function() {
            if ($window._gaq) $window._gaq.push(['_trackPageview', $location.path()]);
            if ($window.ga) $window.ga('send', 'pageview', {page: $location.url()});
        };
        $rootScope.$on('$viewContentLoaded', track);
        $rootScope.$on('$routeChangeSuccess', track);
    }
]);

